import React, { useEffect, useState } from "react";
import { signOut, fetchUserAttributes, fetchAuthSession } from "aws-amplify/auth";
import { clearAllTokens } from '../utils/authUtils';
import { useNavigate, NavLink, Routes, Route, Navigate } from "react-router-dom";
import Profile from '../pages/dashboard/Profile';
import Subscription from '../pages/dashboard/Subscription';
import Settings from '../pages/dashboard/Settings';
import GoodNews from '../pages/dashboard/GoodNews';
import Blog from '../pages/dashboard/Blog';
import BlogDetail from '../pages/dashboard/BlogDetail';
import BlogEditor from '../components/BlogEditor';
import '../styles/Dashboard.css';

export default function Dashboard() {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(true);
  const [expandGoodNews, setExpandGoodNews] = useState(true);

  useEffect(() => {
    async function loadUser() {
      try {
        await fetchUserAttributes();
      } catch (err) {
        console.error("Unable to fetch user attributes:", err);
        navigate("/login");
      }
    }

    async function checkSubscription() {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        if (!token) return setIsActive(false);

        const res = await fetch("https://tx02qpcowl.execute-api.us-east-1.amazonaws.com/user-sub-status", {
          method: "GET",
          mode: "cors",
          headers: { Authorization: `Bearer ${token}` }
        });

        if (!res.ok) {
          const errorBody = await res.text();
          console.error("❌ API returned error:", errorBody);
          return setIsActive(false);
        }

        const data = await res.json();
        setIsActive(data.isActive);
      } catch (err) {
        console.error("🔥 Fetch threw exception:", err);
        setIsActive(false);
      }
    }

    loadUser();
    checkSubscription();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      await clearAllTokens();
      navigate("/login");
    }
  };

  return (
    <div className="dashboard-container">
      <nav className="sidebar">
        <ul className="menu">
          <li><NavLink to="/dashboard/profile" className="menu-link">Profile</NavLink></li>
          <li><NavLink to="/dashboard/subscription" className="menu-link">Subscription</NavLink></li>
          <li><NavLink to="/dashboard/settings" className="menu-link">Settings</NavLink></li>

          <li>
            <button
              className={`menu-toggle ${!isActive ? 'disabled' : ''}`}
              onClick={() => isActive && setExpandGoodNews(!expandGoodNews)}
              disabled={!isActive}
            >
              Good News <span className={`arrow ${expandGoodNews ? 'open' : ''}`}>▸</span>
            </button>
            {expandGoodNews && isActive && (
              <ul className="submenu">
                <li><NavLink to="/dashboard/homilies" className="submenu-link">Homilies</NavLink></li>
                <li><NavLink to="/dashboard/blog" className="submenu-link">Blog</NavLink></li>
              </ul>
            )}
          </li>

          <li><button onClick={handleLogout} className="menu-link">Log Out</button></li>
        </ul>
      </nav>

      <main className="dashboard-main">
        <Routes>
          <Route path="profile" element={<Profile />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="settings" element={<Settings />} />
          <Route path="homilies" element={isActive ? <GoodNews /> : <Navigate to="/dashboard/subscription" replace />} />
          <Route path="blog" element={isActive ? <Blog /> : <Navigate to="/dashboard/subscription" replace />} />
          <Route path="blog/edit" element={isActive ? <BlogEditor /> : <Navigate to="/dashboard/subscription" replace />} />
          <Route path="blog/edit/:id" element={isActive ? <BlogEditor /> : <Navigate to="/dashboard/subscription" replace />} />
          <Route path="blog/:slug" element={isActive ? <BlogDetail /> : <Navigate to="/dashboard/subscription" replace />} />
        </Routes>
      </main>
    </div>
  );
}
